import { Pill } from "lucide-react";

export const Logo = ({ dark = false, size = "md", testId = "brand-logo" }) => {
  const box = size === "sm" ? "h-9 w-9" : "h-11 w-11";
  const icon = size === "sm" ? 18 : 22;
  const text = size === "sm" ? "text-lg" : "text-xl";
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <div
        className={`${box} grid place-items-center rounded-xl shadow-[0_6px_18px_-6px_rgba(30,132,73,0.6)]`}
        style={{ backgroundColor: "var(--action-green)" }}
      >
        <Pill size={icon} className="text-white -rotate-45" strokeWidth={2.4} />
      </div>
      <div className="leading-none">
        <span
          className={`font-display font-extrabold tracking-tight ${text} ${
            dark ? "text-white" : "text-slate-900"
          }`}
        >
          Medicines
        </span>
        <span
          className="font-display font-extrabold tracking-tight ml-1"
          style={{ color: "var(--action-green)" }}
        >
          Now
        </span>
      </div>
    </div>
  );
};

export default Logo;
